import { render } from "./quiz-v1-multiple-select.vue?vue&type=template&id=5969ae2b&scoped=true"
import script from "./quiz-v1-multiple-select.vue?vue&type=script&lang=js"
export * from "./quiz-v1-multiple-select.vue?vue&type=script&lang=js"

import "./quiz-v1-multiple-select.vue?vue&type=style&index=0&id=5969ae2b&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5969ae2b"]])

export default __exports__